<main [formGroup]="form">
  <app-dropdown
    [options]="{
      label: 'Izveštaj',
      type: 'text',
      formControlName: 'report_type',
      value: '',
      optionValue: 'value',
      optionLabel: 'title',
      dropdownOptions: [
        {
          title: 'Po datumu',
          value: 'date'
        },
        { title: 'Do sada', value: 'until_now' }
      ]
    }"
  ></app-dropdown>

  <app-datepicker
    *ngIf="form.get('report_type').value !== 'until_now'"
    [options]="{
      label: 'Od datuma',
      type: 'text',
      formControlName: 'date_from'
    }"
  >
  </app-datepicker>
  <app-datepicker
    *ngIf="form.get('report_type').value !== 'until_now'"
    [options]="{
      label: 'Do datuma',
      type: 'text',
      formControlName: 'date_to'
    }"
  >
  </app-datepicker>

  <button type="button" class="main-btn mt-3" (click)="generateReport()">
    Generiši
  </button>
</main>
